module.exports = __webpack_public_path__ + "static/media/ic-01.50782597.png";